import React from 'react';
import Navbar from '../components/Navbar';
import './About.css';

function About() {
    return (
        <div className="page-container about-page">
            <Navbar />

            <section className="about-hero">
                <div className="container">
                    <div className="about-hero-content">
                        <span className="section-badge">Vår misjon</span>
                        <h1 className="about-title">
                            En bro mellom <span className="gradient-text">gammel visdom</span> og
                            <br />moderne teknologi
                        </h1>
                        <p className="about-subtitle">
                            Vi bringer de evige lærdommene fra Bhagavad Gita til alle gjennom AI
                        </p>
                    </div>
                </div>
            </section>

            <section className="vision-section">
                <div className="container">
                    <div className="vision-grid">
                        <div className="vision-content">
                            <h2 className="section-heading">Visjon</h2>
                            <p className="vision-text">
                                I en verden full av støy og kaos er det vanskelig å finne klar, etisk og spirituell veiledning.
                                Prosjektet "Snakk med Krishna" ble født ut fra ideen om å gjøre den evige visdommen fra Bhagavad Gita tilgjengelig for alle,
                                når som helst og hvor som helst, i sanntid.
                            </p>
                            <p className="vision-text">
                                Ved å kombinere avanserte språkmodeller (LLM) med autentiske hellige tekster har vi skapt et system som ikke bare svarer på spørsmål,
                                men veileder deg med guddommelig medfølelse.
                            </p>

                            <div className="vision-stats">
                                <div className="vision-stat-card">
                                    <div className="stat-icon">📜</div>
                                    <div className="stat-info">
                                        <div className="stat-value">700+</div>
                                        <div className="stat-desc">Autentiske vers</div>
                                    </div>
                                </div>
                                <div className="vision-stat-card">
                                    <div className="stat-icon">🌍</div>
                                    <div className="stat-info">
                                        <div className="stat-value">Tilgang</div>
                                        <div className="stat-desc">Global</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="vision-visual">
                            <div className="visual-card">
                                <div className="visual-icon">🧠</div>
                                <div className="visual-plus">+</div>
                                <div className="visual-icon">📖</div>
                                <div className="visual-equals">=</div>
                                <div className="visual-icon">✨</div>
                            </div>
                            <p className="visual-caption">Fusjon av AI og gamle skrifter</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tech-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Teknologi</span>
                        <h2 className="section-heading-center">
                            Drevet av <span className="gradient-text">banebrytende AI</span>
                        </h2>
                        <p className="section-desc">
                            Vår plattform kombinerer flere avanserte teknologier for å gi en autentisk spirituell opplevelse
                        </p>
                    </div>

                    <div className="tech-grid">
                        <div className="tech-card">
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🔍</div>
                            </div>
                            <h3>RAG-arkitektur</h3>
                            <p>Søke-forsterket generering sikrer at alle svar er basert på virkelige vers fra Bhagavad Gita.</p>
                            <ul className="tech-features">
                                <li>Semantisk søk</li>
                                <li>Kontekstbevissthet</li>
                                <li>Verifiserte kilder</li>
                            </ul>
                        </div>

                        <div className="tech-card featured-tech">
                            <div className="tech-badge">Kjerneteknologi</div>
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🎙️</div>
                            </div>
                            <h3>Nevral stemme</h3>
                            <p>Moderne TTS-modeller gir en realistisk og beroligende lyd for Krishnas stemme.</p>
                            <ul className="tech-features">
                                <li>Naturlige intonasjoner</li>
                                <li>Følelsesmessig uttrykk</li>
                                <li>Sanntidsgenerering</li>
                            </ul>
                        </div>

                        <div className="tech-card">
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🧠</div>
                            </div>
                            <h3>LLM-prosessering</h3>
                            <p>Kraftige språkmodeller forstår ikke bare ordene, men også intensjonen bak spørsmålet ditt.</p>
                            <ul className="tech-features">
                                <li>Kontekstforståelse</li>
                                <li>Flerspråklig støtte</li>
                                <li>Personaliserte svar</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="values-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Våre verdier</span>
                        <h2 className="section-heading-center">
                            Bygget på <span className="gradient-text">tillit</span>
                        </h2>
                    </div>

                    <div className="values-grid">
                        <div className="value-card">
                            <div className="value-number">01</div>
                            <h3>Nøyaktighet i skriftene</h3>
                            <p>Alle svar blir verifisert mot autentiske vers. Vi forvrenger ikke lærdommene.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">02</div>
                            <h3>Tilgjengelighet</h3>
                            <p>Vi bringer gammel visdom til alle, uavhengig av erfaring eller bakgrunn.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">03</div>
                            <h3>Personvern</h3>
                            <p>Din spirituelle vei er personlig. Vi respekterer ditt personvern og deler ikke dine samtaler.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">04</div>
                            <h3>Innovasjon</h3>
                            <p>Vi forbedrer teknologien kontinuerlig for å gi enda dypere veiledning.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="founder-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Lederskap</span>
                        <h2 className="section-heading-center">
                            Om <span className="gradient-text">grunnleggeren</span>
                        </h2>
                    </div>

                    <div className="founder-card">
                        <div className="founder-image-wrapper">
                            <div className="founder-image-bg"></div>
                            <img
                                src="/founder.jpg"
                                alt="Abhishek Chola - Founder & CEO"
                                className="founder-image"
                                onError={(e) => {
                                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f0f0f0" width="400" height="400"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="24" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3EFounder%3C/text%3E%3C/svg%3E';
                                }}
                            />
                        </div>
                        <div className="founder-content">
                            <h3 className="founder-name">Abhishek Chola</h3>
                            <p className="founder-title">Grunnlegger og CEO av Just Learn</p>
                            <div className="founder-divider"></div>
                            <p className="founder-bio">
                                Global innovatør innen EdTech og SkillTech, dedikert til demokratisering av utdanning. 
                                Abhishek leder strategiske initiativer i flere land og fremmer samarbeid mellom utdanning og teknologi.
                            </p>
                            <p className="founder-bio">
                                Hans lederskap fokuserer på skalerbare løsninger ved bruk av AI, AR/VR og immersive teknologier.
                            </p>
                            <div className="founder-highlights">
                                <div className="highlight-item">
                                    <div className="highlight-icon">🌍</div>
                                    <div className="highlight-text">
                                        <strong>Global innvirkning</strong>
                                        <span>Tilstedeværelse i flere land</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <div className="highlight-icon">🚀</div>
                                    <div className="highlight-text">
                                        <strong>Leder innen innovasjon</strong>
                                        <span>AI-, AR/VR-teknologier</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <div className="highlight-icon">🎓</div>
                                    <div className="highlight-text">
                                        <strong>Pioner innen EdTech</strong>
                                        <span>Tilgjengelig utdanning</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta-about">
                <div className="container">
                    <div className="cta-about-card">
                        <h2>Klar til å koble deg til guddommelig visdom?</h2>
                        <p>Start reisen din med AI-mentoren for Bhagavad Gita</p>
                        <button className="btn-premium-primary btn-large" onClick={() => window.location.href = '/chat'}>
                            <span className="btn-icon">🕉️</span>
                            Snakk med Krishna nå
                            <span className="btn-arrow">→</span>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;
